// antd
import { Button } from 'antd';
import React from 'react';

// Components
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
// function
import TranslateText from 'components/hoc/TranslateText';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import routePathEnum from 'enums/routePathEnum';

interface ILogin {}

const NotFound: React.FC<ILogin> = () => {
    const { navigateWorkaround } = useNavigateWorkaround();

    return (
        <AuthWrapper>
            <Title text="NOTFOUND_TITLE" level={5} />
            <Paragraph
                text="NOTFOUND_TEXT"
                style={{
                    paddingTop: 10,
                    display: 'block'
                }}
            />
            <div
                style={{
                    display: 'block',
                    paddingTop: 40
                }}
            >
                <Button
                    style={{
                        marginRight: 20
                    }}
                    type="primary"
                    onClick={() => navigateWorkaround(routePathEnum.LOGIN_ROZCESTNIK)}
                >
                    <TranslateText>PRIHLASIT_SE</TranslateText>
                </Button>
            </div>
        </AuthWrapper>
    );
};

export default NotFound;
